import pluralize from "./pluralize.mjs";
export default (n, label, pluralLabel) => `${n} ${pluralize(n, label, pluralLabel)}`;
//# sourceMappingURL=quantify.mjs.map